import { Table as AccommodationRoomTypeTable } from '@/components/accommodation_room_type/table'

interface Props {
  id: string
}

export const EditRoomTypes = ({ id }: Props) => {
  return (
    <>
      <AccommodationRoomTypeTable
        accommodationId={id}
        pageSize={10}
        title="Room type"
        createable
        fixedHeight
        updateable
      />
    </>
  )
}
